'use client';

import useTheme from '@mui/material/styles/useTheme';
import useMediaQuery from '@mui/material/useMediaQuery';

const useIsMobile = () => {
  const theme = useTheme();

  return useMediaQuery(theme.breakpoints.down('md'));
};
export default useIsMobile;
